import React from "react";
import TimelineData from "./TimelineData";

export default (props) => <TimelineData {...props} />;
